import styled from 'styled-components/macro';
import * as StaffCommon from '../../common/elements/Staff';
import {
  focusRing,
  fontSize,
  layout,
  media,
  neutral,
  radius,
  space,
  transition,
} from '../../../theme/tokens';

export const Inline = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space[3]};
  min-width: 0;
`;

export const SearchForm = styled.form``;

export const SearchField = styled.input`
  width: 100%;
  min-height: ${layout.touchTarget};
  padding: ${space[2]} ${space[4]};
  border: 1px solid ${neutral.border};
  border-radius: ${radius.md};
  background: ${neutral.surface};
  font-family: inherit;
  font-size: ${fontSize.md};
  color: ${({ theme }) => theme.headerColour};
  transition: border-color ${transition.fast};
  ::placeholder {
    color: ${neutral.textMuted};
  }
  &:hover {
    border-color: ${neutral.borderStrong};
  }
  &:focus {
    border-color: ${({ theme }) => theme.buttonPrimary};
  }
  ${focusRing}

  ${media.md`
    width: 26rem;
  `}
`;

export const CardList = styled(StaffCommon.StaffCardGrid)``;

// two columns on phones, then as many 18rem columns as fit
export const FilterBar = styled.section`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  gap: ${space[3]};
  margin-bottom: ${space[4]};

  & .MuiTextField-root {
    min-width: 0;
    width: 100%;
  }

  ${media.sm`
    grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
  `}
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
